angular
	.module('inputName.components', [])
	.component('inputName', {
		templateUrl: 'ng/components/inputName/inputName.html',
		bindings: {
			/** Input data **/
			inputId: '@',
			inputName: '@',
			inputClass: '@',
			inputPlaceholder: '@',
			formName: '=',
			bindingVariable: '=',
			/** Optional data **/
			inputDisableOn: '<',
			isRequired: '<',
			onInputChange: '&?'
		},
		controllerAs: 'inputNameCtrl',
		controller: function ($scope, $translate, validationService) {

			/** not to loose *this reference **/
			var self = this;

			self.validationService = validationService;

			self.$onInit = function () {
				console.log(self);
				self.inputDisableOn = self.inputDisableOn || false;
				self.isRequired = self.isRequired !== false;
			}

			self.$onChanges = function () {

			}

			self.errorMsgShown = false;
			self.validationService = validationService;

			self.resetAlert = function () {
				self.errorMsgShown = false;
			}

			self.showAlertMsg = function () {
				self.errorMsgShown = !self.errorMsgShown;
			}

			self.onChange = function () {
				if (self.onInputChange) {
					self.onInputChange({
						output: self.bindingVariable
					});
				}
			}

		}
	});